$(document).ready(function () {
    var mobileSliderExists = true;

    const hamburgerButton = document.querySelector(".mobile-line-menu .hamburger a");
    const drawerMenu = document.querySelector(".mobile-drawer-menu");
    const drawerCloseBtn = document.querySelector(".mobile-drawer-close");

    let drawerState = 1;
    hamburgerButton.addEventListener("click", (e) => {
        if (drawerMenu.classList.contains("closed")) {
            drawerMenu.classList.remove("closed")
            document.querySelector("#MainContent").classList.add("closed");
            document.querySelector("#shopify-section-footer").classList.add("closed");
        }
    })

    drawerCloseBtn.addEventListener("click", (e) => {
        if (!drawerMenu.classList.contains("closed")) {
            drawerMenu.classList.add("closed")
            document.querySelector("#MainContent").classList.remove("closed");
            document.querySelector("#shopify-section-footer").classList.remove("closed");
        }
    })

    const state1 = document.querySelector(".drawer-state-1");
    const state2 = document.querySelector(".drawer-state-2");
    const state3 = document.querySelector(".drawer-state-3");
    const categoryButtons = document.querySelectorAll(".category-btn.exists");
    const categoryMenus = document.querySelectorAll(".sub-menu.parent");
    const categorySubMenus = document.querySelectorAll(".sub-menu.child");

    const menuTitleBtn = document.querySelectorAll(".menu-title-btn");
    const quickMenuButtons = document.querySelectorAll(".drawer-quick-menu-list .category-btn.exists")

    let activeCategory = "";

    categoryButtons.forEach(btn => {
        btn.addEventListener("click", (event) => {
            activeCategory = event.currentTarget.getAttribute("data-category");
            if (!state1.classList.contains("closed")) state1.classList.add("closed");
            if (state2.classList.contains("closed")) state2.classList.remove("closed");
            if (!state3.classList.contains("closed")) state3.classList.add("closed");
            document.querySelector(".drawer-state-2 .menu-title-text").innerHTML = event.currentTarget.getAttribute("data-category");

            quickMenuButtons.forEach(quickButton => {
                if (quickButton.classList.contains("active")) quickButton.classList.remove("active");
                if (event.currentTarget.getAttribute("data-category") === quickButton.getAttribute("data-category")) quickButton.classList.add("active");
            });

            categoryMenus.forEach(categoryMenu => {
                if (!categoryMenu.classList.contains("closed")) categoryMenu.classList.add("closed");
                if (event.currentTarget.getAttribute("data-category") === categoryMenu.getAttribute("data-category")) categoryMenu.classList.remove("closed");
            });
        })
    });

    const subTitleReturn = document.querySelector(".menu-title.child");

    menuTitleBtn.forEach(btn => {
        btn.addEventListener("click", (event) => {
            if (!state1.classList.contains("closed")) state1.classList.add("closed");
            if (!state2.classList.contains("closed")) state2.classList.add("closed");
            if (state3.classList.contains("closed")) state3.classList.remove("closed");

            document.querySelector(".menu-title.child .menu-title-text").innerHTML = event.currentTarget.getAttribute("data-subtitlename");

            categorySubMenus.forEach(categoryMenu => {
                if (!categoryMenu.classList.contains("closed")) categoryMenu.classList.add("closed");
                if (event.currentTarget.getAttribute("data-submenu") === categoryMenu.getAttribute("data-submenu")) categoryMenu.classList.remove("closed");

            });
        })

    });

    const menuTitle = document.querySelector(".menu-title.parent .menu-title-btn");
    menuTitle.addEventListener("click", (event) => {
        if (state1.classList.contains("closed")) state1.classList.remove("closed");
        if (!state2.classList.contains("closed")) state2.classList.add("closed");
        if (!state3.classList.contains("closed")) state3.classList.add("closed");
    })

    subTitleReturn.addEventListener("click", (event) => {
        if (!state1.classList.contains("closed")) state1.classList.add("closed");
        if (state2.classList.contains("closed")) state2.classList.remove("closed");
        if (!state3.classList.contains("closed")) state3.classList.add("closed");
    })

    $(".header__inline-menu li>a.header__menu-item").mouseenter((e) => {
        const subString = e.currentTarget.getAttribute("data-sub");
        const allMegaMenuInner = document.querySelectorAll(".mega-menu-inner");
        allMegaMenuInner.forEach(element => {
            if (!element.classList.contains("closed")) {
                element.classList.add("closed")
            }
        });
        if (subString) {
            allMegaMenuInner.forEach(element => {
                if (element.getAttribute("data-sub") === subString) {
                    const altMenuList = element.querySelectorAll(".alt-menus .mega-menu-node")

                    const altBannerList = element.querySelectorAll(".banner-blocks .mega-menu-banner")
                    if (altMenuList.length || altBannerList.length) {
                        element.classList.remove("closed");
                        $(".mega-menu").addClass("opened")

                    }
                }
            });
        }
    })
    $("nav.header__inline-menu ul.list-menu.list-menu--inline li>a,.mega-menu-inner").mouseleave((e) => {
        //console.log("nav.header__inline-menu ul.list-menu.list-menu--inline li>a,.mega-menu-inner   mouseleave")
        $(".mega-menu").removeClass("opened")
    })
    $(".mega-menu").mouseenter((e) => {
        //console.log(".mega-menu mouseenter")
        $(".mega-menu").addClass("opened")
    })


});



